module.exports = __webpack_public_path__ + "static/media/07-speaker_profile.60a15018.webp";